import React, { useState } from "react";
import { useEffect } from "react";
import "./Login.css";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
// import { useCart } from "../../pages/CartContext/CartProvider";

const LoginModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;



  return (
    <div className="modalOverlayStyle" onClick={onClose}>
      <div className="modalContentStyle" onClick={e => e.stopPropagation()}>
        <button className="closeButtonStyle" onClick={onClose}>×</button>
        <div className="formContainerStyle">
          <Login onSuccessfulLogin={onClose} />
        </div>
      </div>
    </div>
  );
};
const Login = ({ onSuccessfulLogin }) => {
  const [loginMode, setLoginMode] = useState("otp");
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  // const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [otpExpiresAt, setOtpExpiresAt] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [canResendOtp, setCanResendOtp] = useState(false);
  //   const { cartItems } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  // Styles

  const decodeJWT = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  };


  const handleLoginSuccess = async (token) => {
    const decodedToken = decodeJWT(token);
    if (decodedToken && decodedToken.phoneNumber) {
      const phoneNumber = decodedToken.phoneNumber;
      const role = decodedToken.role;
      // Save auth data
      localStorage.setItem("token", token);
      localStorage.setItem("phoneNumber", phoneNumber);
      localStorage.setItem("role", role);

      // Save cart to database
      //   await saveCartToDatabase(phoneNumber);

      // Handle redirect logic
      const returnToCheckout = localStorage.getItem("returnToCheckout");
      if (returnToCheckout === "true") {
        localStorage.removeItem("returnToCheckout");
        navigate("/checkout");
      } else {
        const from = location.state?.from || "/";
        onSuccessfulLogin?.();
        navigate(from);
      }
    } else {
      console.error("Failed to extract phoneNumber from token");
      setError("Login failed. Please try again.");
    }
  };



  // const handleLoginSuccess = async (token) => {
  //   const decodedToken = decodeJWT(token);
  //   if (decodedToken && decodedToken.phoneNumber) {
  //     const phoneNumber = decodedToken.phoneNumber;
  //     const role = decodedToken.role;

  //     // Save auth data
  //     localStorage.setItem("token", token);
  //     localStorage.setItem("phoneNumber", phoneNumber);
  //     localStorage.setItem("role", role);

  //     // Save cart to database
  //     await saveCartToDatabase(phoneNumber);

  //     // Redirect based on role
  //     const returnToCheckout = localStorage.getItem("returnToCheckout");
  //     if (returnToCheckout === "true") {
  //       localStorage.removeItem("returnToCheckout");
  //       navigate("/checkout");
  //     } else if (role === "admin") {
  //       navigate("/admindashboard");
  //     } else {
  //       const from = location.state?.from || "/";
  //       onSuccessfulLogin?.();
  //       navigate(from);
  //     }
  //   } else {
  //     console.error("Failed to extract phoneNumber from token");
  //     setError("Login failed. Please try again.");
  //   }
  // };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      if (loginMode === "password") {
        const response = await axios.post("/api/login", {
          identifier,
          password,
        });
        await handleLoginSuccess(response.data.token);
      } else if (loginMode === "otp") {
        if (!otpSent) {
          await sendOTP();
        } else {
          const response = await axios.post("/api/verify-otp", {
            phoneNumber: identifier,
            otp,
          });
          await handleLoginSuccess(response.data.token);
        }
      }
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const sendOTP = async () => {
    try {
      const response = await axios.post("/api/send-otp", {
        phoneNumber: identifier,
      });
      alert(response.data.message);
      setOtpSent(true);

      // Set initial countdown to 5 minutes
      const expirationTime = Date.now() + 5 * 60 * 1000;
      setOtpExpiresAt(expirationTime);

      // Initialize countdown
      setCountdown(5 * 60);
      setCanResendOtp(false);
    } catch (error) {
      setError(error.response?.data?.message || "Failed to send OTP");
    }
  };

  const handleResendOTP = async () => {
    if (!canResendOtp) return;

    try {
      await sendOTP();
    } catch (error) {
      setError("Failed to resend OTP");
    }
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prevCountdown => {
          if (prevCountdown <= 1) {
            clearInterval(timer);
            setCanResendOtp(true);
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [countdown]);
  const formatCountdown = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };




  const isLoggedIn = localStorage.getItem("token");
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phoneNumber");
    alert("You have logged out successfully.");
    navigate("/login");
  };



  const [otp, setOtp] = useState("");

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!isNaN(value) && value.length <= 1) {
      const newOtp = otp.split("");
      newOtp[index] = value;
      const updatedOtp = newOtp.join("");
      setOtp(updatedOtp);

      // Automatically focus next input
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  return (
    <div className="containerStyle">
      <div className="formStyle">
        {isLoggedIn ? (
          <button
            onClick={handleLogout}
            className="buttonStyle"
          >
            Logout
          </button>
        ) : (

          <form onSubmit={handleLoginSubmit} >
            <div className="inputGroupStyle">
              {loginMode === "otp" && (
                <>
                  <div>
                    {/* <label className="labelStyle">Mobile Number</label> */}
                    <input
                      type="tel"
                      value={identifier}
                      onChange={(e) => setIdentifier(e.target.value)}
                      className="inputStyle"
                      placeholder="10-digit phone number"
                      required
                    />
                  </div>
             

                  {/* {otpSent && (
                <div>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="inputStyle}
                    placeholder="----"
                    required
                  />
                </div>
              )} */}
                  <div className="otp-input-container">
                    {/* {otpSent && [...Array(6)].map((_, index) => (
                    <input
                      key={index}
                      id={`otp-input-${index}`}
                      type="text"
                      value={otp[index] || ""}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      maxLength="1"
                      className="otp-input"
                    />
                  ))} */}


                    {otpSent && (
                      <div>
                        <div className="otp-input-container">
                          {/* Render OTP input fields */}
                          {[...Array(6)].map((_, index) => (
                            <input
                              key={index}
                              id={`otp-input-${index}`}
                              type="text"
                              value={otp[index] || ""}
                              onChange={(e) => handleChange(e, index)}
                              onKeyDown={(e) => handleKeyDown(e, index)}
                              maxLength="1"
                              className="otp-input"
                            />
                          ))}
                        </div>
                        {/* Render the resend OTP button once */}
                        <div className="linkTextStyle">
                          <button
                            type="button"
                            onClick={handleResendOTP}
                            style={{

                              opacity: canResendOtp ? 1 : 0.5,
                              cursor: canResendOtp ? 'pointer' : 'not-allowed'
                            }}
                            disabled={!canResendOtp}
                          >
                            {!canResendOtp
                              ? `Resend OTP in ${formatCountdown(countdown)}`
                              : "Resend OTP"}
                          </button><br /><br />

                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}

              {loginMode === "password" && (
                <>
                  <div>
                    <input
                      type="text"
                      value={identifier}
                      onChange={(e) => setIdentifier(e.target.value)}
                      className="inputStyle"
                      placeholder="Email or mobile number"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className="inputStyle"
                      placeholder="Password"
                      required
                    />
                  </div>
                </>
              )}
            </div>

            {error && <p className="errorStyle">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="buttonStyle"
            >
              {loading
                ? "Please wait..."
                : loginMode === "password"
                  ? "Login"
                  : otpSent
                    ? "Verify OTP"
                    : "SEND OTP"}

            </button>

            {loginMode === "otp" && (
              <div className="linkTextStyle">
                Login using your email & password{" "}
                <button
                  type="button"
                  onClick={() => setLoginMode("password")}
                  className="clickHereStyle"
                >
                  Click here
                </button>
                {/* <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-end mb-20">
                               <a href="/LeftSideNavaBarAdmin" class="link style1">Forgot Password?</a>
                             </div> */}
              </div>
            )}

            {loginMode === "password" && (
              <div className="linkTextStyle">
                <button
                  type="button"
                  onClick={() => setLoginMode("otp")}
                  className="clickHereStyle"
                >
                  Login with OTP instead
                </button>
              </div>
            )}
          </form>
        )
        }
      </div>
      <div className="loginlogo">
        <img src="/assets/img/logo.png" alt="logo" />
      </div>
    </div>
  );
};

export default LoginModal;


